/**
 * Historical Periods Data
 * Japanese and Chinese historical periods for timeline visualization
 */

export const historicalPeriods = {
  japan: [
    {
      name: "飛鳥時代",
      nameEn: "Asuka Period",
      start: 538,
      end: 710,
      color: "#D0E8F0",
      borderColor: "#A0C4D8"
    },
    {
      name: "奈良時代",
      nameEn: "Nara Period",
      start: 710,
      end: 794,
      color: "#E0D0F0",
      borderColor: "#C0A0D8"
    },
    {
      name: "平安時代",
      nameEn: "Heian Period",
      start: 794,
      end: 1185,
      color: "#F0E0D0",
      borderColor: "#D8C0A0"
    },
    {
      name: "鎌倉時代",
      nameEn: "Kamakura Period",
      start: 1185,
      end: 1333,
      color: "#D0F0D0",
      borderColor: "#A0D8A0"
    },
    {
      name: "室町時代",
      nameEn: "Muromachi Period",
      start: 1333,
      end: 1573,
      color: "#F0D0D0",
      borderColor: "#D8A0A0"
    },
    {
      name: "安土桃山時代",
      nameEn: "Azuchi-Momoyama Period",
      start: 1573,
      end: 1603,
      color: "#E8D0E0",
      borderColor: "#D0A0C0"
    },
    {
      name: "江戸時代",
      nameEn: "Edo Period",
      start: 1603,
      end: 1868,
      color: "#D0E0F0",
      borderColor: "#A0C0D8"
    },
    {
      name: "明治時代",
      nameEn: "Meiji Period",
      start: 1868,
      end: 1912,
      color: "#E0F0D0",
      borderColor: "#C0D8A0"
    },
    {
      name: "大正時代",
      nameEn: "Taisho Period",
      start: 1912,
      end: 1926,
      color: "#F0F0D0",
      borderColor: "#D8D8A0"
    },
    {
      name: "昭和時代",
      nameEn: "Showa Period",
      start: 1926,
      end: 1989,
      color: "#D0D0F0",
      borderColor: "#A0A0D8"
    },
    {
      name: "平成時代",
      nameEn: "Heisei Period",
      start: 1989,
      end: 2019,
      color: "#F0E8D0",
      borderColor: "#D8C8A0"
    },
    {
      name: "令和時代",
      nameEn: "Reiwa Period",
      start: 2019,
      end: new Date().getFullYear(),
      color: "#E8D0F0",
      borderColor: "#C8A0D8"
    }
  ],

  china: [
    {
      name: "春秋戦国時代",
      nameEn: "Spring & Autumn / Warring States",
      start: -770,
      end: -221,
      color: "#E0D8C8",
      borderColor: "#C8B8A0"
    },
    {
      name: "秦朝",
      nameEn: "Qin Dynasty",
      start: -221,
      end: -206,
      color: "#D0E8D8",
      borderColor: "#A8D0B8"
    },
    {
      name: "漢朝",
      nameEn: "Han Dynasty",
      start: -206,
      end: 220,
      color: "#E0D0E8",
      borderColor: "#C0A8D0"
    },
    {
      name: "三国時代",
      nameEn: "Three Kingdoms",
      start: 220,
      end: 280,
      color: "#E8D0E0",
      borderColor: "#D0A8C0"
    },
    {
      name: "晋朝",
      nameEn: "Jin Dynasty",
      start: 280,
      end: 420,
      color: "#D0E0E8",
      borderColor: "#A8C0D0"
    },
    {
      name: "南北朝時代",
      nameEn: "Northern & Southern Dynasties",
      start: 420,
      end: 589,
      color: "#E0E8D0",
      borderColor: "#C0D0A8"
    },
    {
      name: "隋朝",
      nameEn: "Sui Dynasty",
      start: 589,
      end: 618,
      color: "#E8D0D0",
      borderColor: "#D0A8A8"
    },
    {
      name: "唐朝",
      nameEn: "Tang Dynasty",
      start: 618,
      end: 907,
      color: "#D0D0E8",
      borderColor: "#A8A8D0"
    },
    {
      name: "五代十国",
      nameEn: "Five Dynasties & Ten Kingdoms",
      start: 907,
      end: 960,
      color: "#E8E8D0",
      borderColor: "#D0D0A8"
    },
    {
      name: "宋朝",
      nameEn: "Song Dynasty",
      start: 960,
      end: 1279,
      color: "#D0E8E8",
      borderColor: "#A8D0D0"
    },
    {
      name: "元朝",
      nameEn: "Yuan Dynasty",
      start: 1279,
      end: 1368,
      color: "#E8D0E8",
      borderColor: "#D0A8D0"
    },
    {
      name: "明朝",
      nameEn: "Ming Dynasty",
      start: 1368,
      end: 1644,
      color: "#E0E8E0",
      borderColor: "#C0D0C0"
    },
    {
      name: "清朝",
      nameEn: "Qing Dynasty",
      start: 1644,
      end: 1912,
      color: "#E8E0E8",
      borderColor: "#D0C0D0"
    },
    {
      name: "中華民国",
      nameEn: "Republic of China",
      start: 1912,
      end: 1949,
      color: "#E0E0E8",
      borderColor: "#C0C0D0"
    },
    {
      name: "中華人民共和国",
      nameEn: "People's Republic of China",
      start: 1949,
      end: new Date().getFullYear(),
      color: "#E8E8E0",
      borderColor: "#D0D0C0"
    }
  ]
};

/**
 * Gets periods that overlap with a given time range
 */
export function getPeriodsInRange(country, startYear, endYear) {
  const periods = historicalPeriods[country] || [];

  return periods.filter(period => {
    // Check if period overlaps with the given range
    return period.end >= startYear && period.start <= endYear;
  });
}

/**
 * Gets the period for a specific year
 */
export function getPeriodForYear(country, year) {
  const periods = historicalPeriods[country] || [];

  return periods.find(period =>
    year >= period.start && year <= period.end
  );
}

/**
 * Gets period color for a person based on their lifespan
 */
export function getPersonPeriodColor(person, country = 'japan') {
  // Parse person's years to get their primary period
  const yearMatch = person.years?.match(/(\d{4})/);
  if (!yearMatch) return null;

  const year = parseInt(yearMatch[1]);
  const period = getPeriodForYear(country, year);

  return period ? {
    color: period.color,
    borderColor: period.borderColor,
    period: period.name,
    periodEn: period.nameEn
  } : null;
}

/**
 * Creates period legend data
 */
export function createPeriodLegend(country, visibleRange) {
  const periods = getPeriodsInRange(country, visibleRange.min, visibleRange.max);

  return periods.map(period => ({
    ...period,
    isVisible: true,
    coverage: {
      start: Math.max(period.start, visibleRange.min),
      end: Math.min(period.end, visibleRange.max)
    }
  }));
}

export default historicalPeriods;